import { AbstractRequestor, type IRequestConfig } from './AbstractRequestor';
import { sourceHeader, X_SOLINK_SOURCE } from './source';

export class AuthenticatedRequestor extends AbstractRequestor {
  constructor(
    baseURL: string,
    timeout: number,
    authToken: string,
    sendCustomHeader: boolean = true,
  ) {
    const headers: { Authorization: string; [X_SOLINK_SOURCE]?: string } = {
      Authorization: `Bearer ${authToken}`,
    };

    if (sendCustomHeader) {
      headers[X_SOLINK_SOURCE] = sourceHeader();
    }

    super({
      baseURL,
      timeout,
      headers,
    });
  }

  protected _request_<T>(config: IRequestConfig) {
    return super._request_<T>(config);
  }
}
